import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";
import { useVisitQuery } from "hooks/queries/useVisitQuery";
import { extendedVisitRecommendedScanStartTime } from "lib/extendedVisitRecommendedScanStartTime";
import { CheckInParams } from "lib/types/checkInParameters";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent";
import { ExtendedBloodDrawSteps } from "render/ui/presentation/ExtendedBloodDrawSteps";
import { Sangra75PilotTag } from "render/ui/presentation/Sangra75PilotTag";
import styles from "./styles.module.sass";

type ExtendedVisitBloodDrawOutroProps = {
  goTo(url: string): void;
} & CheckInParams;

export function ExtendedVisitBloodDrawOutro({
  goTo,
  patientId,
  visitId,
}: ExtendedVisitBloodDrawOutroProps) {
  const { data: visit } = useVisitQuery({ patientId, visitId });
  const recommendedScanStartTime = visit
    ? extendedVisitRecommendedScanStartTime({
        startTime: visit.startTime,
        countryCode: visit.site.address.countryCode?.toUpperCase(),
      })
    : undefined;

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <section className={styles.layout}>
            <Sangra75PilotTag />
            <Typography variant="display-s">Extended Blood Test</Typography>
            <Typography variant="body-m" color="subtle">
              Blood draw completed. The member can now be escorted to reception.
            </Typography>
            <div className={styles.list}>
              <ExtendedBloodDrawSteps
                activeStep={2}
                recommendedScanStartTime={recommendedScanStartTime}
              />
            </div>
          </section>
        }
        buttons={
          <Button
            onPress={() => goTo(paths.root.url({}))}
            fillContainer
            icon={<Icon24ArrowRight />}
          >
            Continue
          </Button>
        }
      />
    </PageFrameContent>
  );
}
